module.exports = __webpack_public_path__ + "8deac97e013796ca5ba414f474b50255.jpg";